import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=16a65d7f&scoped=true&"
import script from "./Info.vue?vue&type=script&lang=js&"
export * from "./Info.vue?vue&type=script&lang=js&"
import style0 from "./Info.vue?vue&type=style&index=0&id=16a65d7f&scoped=true&lang=scss&"
import style1 from "./Info.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a65d7f",
  null
  
)

export default component.exports